import Slider from 'react-slick';

import ProjectItem from './ProjectItem';
import './ProjectsSlider.css';

const PrevArrow = ({ currentSlide, slideCount, ...props }) => {
  return (
    <i
      {...props}
      className={'fas fa-chevron-left projects__slider__arrow-left'}
    ></i>
  );
};
const NextArrow = ({ currentSlide, slideCount, ...props }) => {
  return (
    <i
      {...props}
      className={'fas fa-chevron-right projects__slider__arrow-right'}
    ></i>
  );
};

function ProjectsSlider({ projects }) {
  const settings = {
    prevArrow: <PrevArrow />,
    nextArrow: <NextArrow />,
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 1,
    initialSlide: 0,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 0,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 0,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 0,
        },
      },
    ],
  };

  return (
    <div className="projects__slider">
      <Slider {...settings}>
        {projects.map((each, key) => {
          return <ProjectItem key={key} data={each} />;
        })}
      </Slider>
    </div>
  );
}

export default ProjectsSlider;
